function Timeout() {
    this._raf = window.requestAnimationFrame
        || 	window.mozRequestAnimationFrame
        || 	window.webkitRequestAnimationFrame
        || 	window.msRequestAnimationFrame;

    this._callback = null;
    this._timeout = null;
    this._pointer = null;
    this._start = null;

    this._performance = window.performance ? window.performance : window.Date;
}

Timeout.prototype.set = set;
Timeout.prototype.reset = reset;

Timeout.prototype._step = step;

function set(callback, timeout) {
    this._start = this._performance.now();
    this._timeout = timeout;
    this._callback = callback;

    this._pointer = this._raf.call(window, this._step.bind(this));
}

function step() {
    if (!this._start) { console.error('Start time is not set!'); return; }
    var curr = this._performance.now();
    if (curr - this._start >= this._timeout) {
       this._callback();
       // console.log('Callback is run');
    } else {
        this._pointer = this._raf.call(window, this._step.bind(this));
    }
}

function reset() {
    if (!this._pointer) return;
    const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

    cancelAnimationFrame(this._pointer);
    this._pointer = null;
}

export default Timeout;
